// Takes in state and returns pricingInfo json object
function getPricingInfoFromState(state) {
    const listingPage = state.listingPageReducer;

    // Graphql pricing details
    const priceDetails =
        listingPage.priceDetails && listingPage.priceDetails.toJS
            ? listingPage.priceDetails.toJS()
            : listingPage.priceDetails || {};
    const graphqlDetails = priceDetails.priceDetails || {totals: []};
    graphqlDetails.tripTotal =
        graphqlDetails.totals && graphqlDetails.totals.length
            ? graphqlDetails.totals[graphqlDetails.totals.length - 1].amount
            : '';

    return graphqlDetails;
}

export default getPricingInfoFromState;
export {getPricingInfoFromState};
